module.exports = __webpack_public_path__ + "static/media/button-expand-window.151c1d52.svg";